import React from "react";
import { useTheme } from '@mui/material/styles';
import { Box } from "@mui/material";

const PerkStatus = ({ status }) => {
  const theme = useTheme();
  if (status === 1) {
    return (
      <Box
        sx={{
          backgroundColor: theme.palette.mode === 'light' ? '#fff8dd' : '#392f28',
          borderRadius: '6px',
          color: '#ffc700',
          fontSize: '11px',
          lineHeight: '12px',
          fontWeight: 600,
          padding: '10px 13px'
        }}
      >
        Inactive
      </Box>
    );
  } else if (status === 2) {
    return (
      <Box
        sx={{
          backgroundColor: theme.palette.mode === 'light' ? '#fff5f8' : '#3a2434',
          borderRadius: '6px',
          color: '#fa416c',
          fontSize: '11px',
          lineHeight: '12px',
          fontWeight: 600,
          padding: '10px 13px'
        }}
      >
        Expired
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          backgroundColor: theme.palette.mode === 'light' ? '#e8fff3' : '#1c3238',
          borderRadius: '6px',
          color: '#50cd89',
          fontSize: '11px',
          lineHeight: '12px',
          fontWeight: 600,
          padding: '10px 13px'
        }}
      >
        Active
      </Box>
    );
  }
}

export default PerkStatus;
